<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span class="fw-medium">
        <i class="fa-solid fa-box text-secondary me-1" />
        {{ item.name }}
      </span>
      <button
        type="button"
        @click="$parent.deleteItemOutput(index)"
        class="btn btn-sm btn-outline-danger"
        :title="$t('Delete')"
        style="--bs-btn-padding-y: .15rem; --bs-btn-padding-x: .4rem;"
      >
        <i class="fa-solid fa-trash" />
      </button>
    </div>
    <div class="row g-2">
      <div class="col-6 col-md-4">
        <label
          :for="'quantity'+index"
          class="form-label small text-secondary mb-1"
        >
          {{ $t('Quantity') }}
          <span class="text-danger">*</span>
        </label>
        <div class="input-group input-group-sm">
          <input
            :id="'quantity'+index"
            type="number"
            inputmode="decimal"
            v-model.trim="v$.item.quantity.$model"
            class="form-control shadow-none"
            :placeholder="$t('Enter quantity') + '...'"
          >
          <span class="input-group-text">{{ $t(item.unit_name) }}</span>
        </div>
        <div v-for="error of v$.item.quantity.$errors"
          class="d-block invalid-feedback"
          :key="error.$uid"
        >
          {{ error.$message }}
        </div>
      </div>
      <div class="col-6 col-md-5">
        <label
          :for="'shelf_life_value'+index"
          class="form-label small text-secondary mb-1"
        >
          {{ $t('Shelf Life') }}
          <span class="text-danger">*</span>
        </label>
        <div class="input-group input-group-sm">
          <input
            :id="'shelf_life_value'+index"
            type="number"
            inputmode="numeric"
            v-model.trim="v$.item.shelf_life_value.$model"
            class="form-control shadow-none"
            :placeholder="$t('Enter shelf life value') + '...'"
          >
          <select
            class="form-select shadow-none"
            v-model.trim="v$.item.shelf_life_unit.$model"
            style="text-transform: capitalize; max-width: 90px;"
          >
            <option
              v-for="unit in optionsShelfLifeUnits"
              :value="unit"
              style="text-transform: capitalize"
            >
              {{ $t(unit) }}
            </option>
          </select>
          <div v-for="error of v$.item.shelf_life_value.$errors"
            class="d-block invalid-feedback"
            :key="error.$uid"
          >
            {{ error.$message }}
          </div>
          <div v-for="error of v$.item.shelf_life_unit.$errors"
            class="d-block invalid-feedback"
            :key="error.$uid"
          >
            {{ error.$message }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <label
          :for="'cost_allocation_percent'+index"
          class="form-label small text-secondary mb-1"
        >
          {{ $t('Cost Alloc.') }}
          <span class="text-danger">*</span>
        </label>
        <div class="input-group input-group-sm">
          <input
            :id="'cost_allocation_percent'+index"
            type="number"
            inputmode="decimal"
            v-model.trim="v$.item.cost_allocation_percent.$model"
            class="form-control shadow-none"
            :placeholder="$t('Enter cost allocation') + '...'"
          >
          <span class="input-group-text">%</span>
          <div v-for="error of v$.item.cost_allocation_percent.$errors"
            class="d-block invalid-feedback"
            :key="error.$uid"
          >
            {{ error.$message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-output-item";
import moment from "moment";
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.item)
  },
  props: {
    item: {
      type: Object,
      default: [{
        inventory_id: '',
        name: '',
        unit_id: '',
        unit_name: '',
        quantity: '',
        cost_allocation_percent: '',
        shelf_life_value: '',
        shelf_life_unit: 'day'
      }]
    },
    index: {
      type: Number,
      required: true
    },
    optionsShelfLifeUnits: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
    }
  },
  components: {
    Select2
  },
  methods: {
    async onSelectedUnit(e) {
      this.item.inventory_unit_id = e.inventory_unit_id;
      this.item.conversion_factor = e.conversion_factor;
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
  },
  async mounted() {

  },
  computed: {},
  watch: {}
}
</script>
